<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">市场管理</Breadcrumb-item>
        <Breadcrumb-item>渠道成交率</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div style="margin-top: 10px">
      <Form :label-width="80" :show-message="false">
        <Row>
          <Col span="16">
            <Form-item label="统计周:">
              <DatePicker :value="dateRange" @on-change="onRangeChange" format="yyyy-MM-dd" type="daterange"
                          :clearable="false" placement="bottom-start" placeholder=""
                          style="width: 220px"></DatePicker>
              <Button type="primary" :loading="searchLoading" icon="search" style="margin-left: 8px" @click="search">搜索</Button>
              <Button type="primary" :loading="exportLoading" style="margin-left: 8px" @click="exportData">导出</Button>
            </Form-item>
          </Col>
        </Row>
      </Form>
    </div>
    <div v-if="dimension !== 'category'" style="margin-bottom: 10px">
      <Button icon="ios-arrow-back" @click="backToCategory">返回</Button>
    </div>
    <Table ref="dealTable" :height="tableHeight" :columns="columns" :data="list" :loading="searchLoading" :row-class-name="rowClassName"></Table>
    <div style="margin-top: 12px">
      合计：分配 {{ totalAssignCount }}，累计成交 {{ totalDealCount }}，累计成交率 {{ formatRate(totalDealRate) }}，当前成交 {{ totalCurrentDealCount }}，当前成交率 {{ formatRate(totalCurrentDealRate) }}
    </div>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        searchLoading: false,
        exportLoading: false,
        startDate: '',
        endDate: '',
        dateRange: [],
        dimension: 'category',
        marketCategoryKey: '',
        searchSeq: 0,
        list: [],
        totalAssignCount: 0,
        totalDealCount: 0,
        totalDealRate: null,
        totalCurrentDealCount: 0,
        totalCurrentDealRate: null,
        tableHeight: null,
        channelColumns: [
          {
            title: '渠道名称',
            key: 'channelName',
            sortable: true,
            sortMethod: this.sortText
          },
          {
            title: '渠道分类',
            key: 'channelType',
            sortable: true,
            sortMethod: this.sortText
          },
          {
            title: '分配数量',
            key: 'assignCount',
            sortable: true,
            sortMethod: this.sortNumber,
            render: (h, params) => {
              const count = params.row.assignCount == null ? 0 : params.row.assignCount
              const href = this.$router.resolve({
                path: '/crm/DistributionList',
                query: this.assignQuery(params.row)
              }).href
              return h('a', {
                attrs: { href: href },
                style: { color: '#2d8cf0' },
                on: {
                  click: (e) => {
                    if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) {
                      return
                    }
                    e.preventDefault()
                    this.$router.push({
                      path: '/crm/DistributionList',
                      query: this.assignQuery(params.row)
                    })
                  }
                }
              }, String(count))
            }
          },
          {
            title: '累计成交数量',
            key: 'dealCount',
            sortable: true,
            sortMethod: this.sortNumber,
            render: (h, params) => {
              const count = params.row.dealCount == null ? 0 : params.row.dealCount
              const href = this.$router.resolve({
                path: '/order/performanceDetail',
                query: this.dealQuery(params.row)
              }).href
              return h('a', {
                attrs: { href: href },
                style: { color: '#2d8cf0' },
                on: {
                  click: (e) => {
                    if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) {
                      return
                    }
                    e.preventDefault()
                    this.$router.push({
                      path: '/order/performanceDetail',
                      query: this.dealQuery(params.row)
                    })
                  }
                }
              }, String(count))
            }
          },
          {
            title: '累计成交率',
            key: 'dealRate',
            sortable: true,
            sortMethod: this.sortNumber,
            render: (h, params) => h('span', this.formatRate(params.row.dealRate))
          },
          {
            title: '当前成交数量',
            key: 'currentDealCount',
            sortable: true,
            sortMethod: this.sortNumber
          },
          {
            title: '当前成交率',
            key: 'currentDealRate',
            sortable: true,
            sortMethod: this.sortNumber,
            render: (h, params) => h('span', this.formatRate(params.row.currentDealRate))
          }
        ],
        categoryColumns: [
          {
            title: '市场分类',
            key: 'marketCategory',
            sortable: true,
            sortMethod: this.sortText,
            render: (h, params) => {
              const text = params.row.marketCategory
              const href = this.$router.resolve({
                path: '/market/ChannelDealRate',
                query: this.categoryQuery(params.row)
              }).href
              return h('a', {
                attrs: { href: href },
                style: { color: '#2d8cf0' },
                on: {
                  click: (e) => {
                    if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) {
                      return
                    }
                    e.preventDefault()
                    this.enterCategory(params.row.marketCategoryKey)
                  }
                }
              }, text == null ? '' : String(text))
            }
          },
          {
            title: '分配数量',
            key: 'assignCount',
            sortable: true,
            sortMethod: this.sortNumber,
            render: (h, params) => {
              const count = params.row.assignCount == null ? 0 : params.row.assignCount
              return h('span', String(count))
            }
          },
          {
            title: '累计成交数量',
            key: 'dealCount',
            sortable: true,
            sortMethod: this.sortNumber,
            render: (h, params) => {
              const count = params.row.dealCount == null ? 0 : params.row.dealCount
              return h('span', String(count))
            }
          },
          {
            title: '累计成交率',
            key: 'dealRate',
            sortable: true,
            sortMethod: this.sortNumber,
            render: (h, params) => h('span', this.formatRate(params.row.dealRate))
          },
          {
            title: '当前成交数量',
            key: 'currentDealCount',
            sortable: true,
            sortMethod: this.sortNumber
          },
          {
            title: '当前成交率',
            key: 'currentDealRate',
            sortable: true,
            sortMethod: this.sortNumber,
            render: (h, params) => h('span', this.formatRate(params.row.currentDealRate))
          }
        ]
      }
    },
    computed: {
      columns () {
        if (this.dimension === 'category') {
          return this.categoryColumns
        }
        return this.channelColumns
      }
    },
    created () {
      const query = this.$route.query
      if (query.marketCategory) {
        this.dimension = 'channel'
        this.marketCategoryKey = query.marketCategory
      }
      if (query.startDate && query.endDate) {
        this.setRange(query.startDate, query.endDate)
        this.search()
      } else if (query.weekStart) {
        const start = this.$moment(query.weekStart, 'YYYY-MM-DD').startOf('isoWeek')
        this.setRange(start.format('YYYY-MM-DD'), start.clone().add(6, 'days').format('YYYY-MM-DD'))
        this.search()
      } else {
        this.goThisWeek()
      }
    },
    mounted () {
      this.onResize = () => {
        this.updateTableHeight()
      }
      window.addEventListener('resize', this.onResize)
      this.updateTableHeight()
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.onResize)
    },
    watch: {
      list () {
        this.updateTableHeight()
      },
      dimension () {
        this.updateTableHeight()
      }
    },
    methods: {
      updateTableHeight () {
        this.$nextTick(() => {
          const table = this.$refs.dealTable
          if (!table || !table.$el) {
            return
          }
          const el = table.$el
          const main = document.querySelector('.layout-content-main')
          const mainBottom = main ? main.getBoundingClientRect().bottom : window.innerHeight
          const visibleBottom = Math.min(mainBottom, window.innerHeight)
          const available = Math.floor(visibleBottom - el.getBoundingClientRect().top - 64)
          const header = el.querySelector('.ivu-table-header')
          const rows = el.querySelectorAll('.ivu-table-tbody tr')
          let content = header ? header.offsetHeight : 40
          for (let i = 0; i < rows.length; i++) {
            content += rows[i].offsetHeight || 48
          }
          if (!rows.length) {
            content += 48
          }
          const next = content > available && available > 80 ? available : null
          if (next !== this.tableHeight) {
            this.tableHeight = next
          }
        })
      },
      setRange (start, end) {
        this.startDate = start
        this.endDate = end
        this.dateRange = [start, end]
      },
      onRangeChange (value) {
        if (!value || !value[0] || !value[1]) {
          this.dateRange = [this.startDate, this.endDate]
          return
        }
        this.setRange(value[0], value[1])
      },
      goThisWeek () {
        const start = this.$moment().startOf('isoWeek')
        this.setRange(start.format('YYYY-MM-DD'), start.clone().add(6, 'days').format('YYYY-MM-DD'))
        this.search()
      },
      channelIdOf (row) {
        if (row.channelId == null || row.channelId === '') {
          return 0
        }
        return row.channelId
      },
      withMarketCategory (query) {
        if (this.marketCategoryKey) {
          query.marketCategory = this.marketCategoryKey
        }
        return query
      },
      categoryQuery (row) {
        const query = {}
        if (this.startDate && this.endDate) {
          query.startDate = this.startDate
          query.endDate = this.endDate
        }
        if (row.marketCategoryKey) {
          query.marketCategory = row.marketCategoryKey
        }
        return query
      },
      enterCategory (key) {
        if (!key) {
          return
        }
        this.dimension = 'channel'
        this.marketCategoryKey = key
        this.list = []
        this.syncLevelQuery()
        this.search()
      },
      backToCategory () {
        this.dimension = 'category'
        this.marketCategoryKey = ''
        this.list = []
        this.syncLevelQuery()
        this.search()
      },
      syncLevelQuery () {
        const query = {}
        if (this.startDate && this.endDate) {
          query.startDate = this.startDate
          query.endDate = this.endDate
        }
        if (this.dimension !== 'category' && this.marketCategoryKey) {
          query.marketCategory = this.marketCategoryKey
        }
        this.$router.replace({
          path: '/market/ChannelDealRate',
          query: query
        })
      },
      assignQuery (row) {
        return this.withMarketCategory({
          channelDealRate: 1,
          channelId: this.channelIdOf(row),
          weekStart: this.startDate,
          linkStartTimeDate: this.startDate,
          linkEndTimeDate: this.endDate,
          startDate: this.startDate,
          endDate: this.endDate
        })
      },
      dealQuery (row) {
        return this.withMarketCategory({
          channelDealRate: 1,
          channelId: this.channelIdOf(row),
          startDate: this.startDate,
          endDate: this.endDate,
          weekStart: this.startDate
        })
      },
      sortText (a, b, type) {
        const left = a === null || a === undefined ? '' : String(a)
        const right = b === null || b === undefined ? '' : String(b)
        const result = left.localeCompare(right, 'zh')
        return type === 'desc' ? -result : result
      },
      sortNumberValue (value) {
        if (value === null || value === undefined || value === '') {
          return null
        }
        const number = Number(value)
        if (isNaN(number)) {
          return null
        }
        return number
      },
      sortNumber (a, b, type) {
        const left = this.sortNumberValue(a)
        const right = this.sortNumberValue(b)
        if (left === null && right === null) {
          return 0
        }
        if (left === null) {
          return type === 'desc' ? 1 : -1
        }
        if (right === null) {
          return type === 'desc' ? -1 : 1
        }
        const result = left - right
        return type === 'desc' ? -result : result
      },
      formatRate (rate) {
        if (rate === null || rate === undefined || rate === '') {
          return '-'
        }
        return this.$numeral(Number(rate) * 100).format('0.00') + '%'
      },
      rowClassName (row) {
        if (row.dealRate === null || row.dealRate === undefined || row.dealRate === '') {
          return ''
        }
        return Number(row.dealRate) < 0.07 ? 'low-deal-rate' : ''
      },
      exportData () {
        this.exportLoading = true
        const params = {
          startDate: this.startDate,
          endDate: this.endDate
        }
        if (this.dimension === 'category') {
          params.dimension = 'category'
        } else if (this.marketCategoryKey) {
          params.marketCategory = this.marketCategoryKey
        }
        this.$http.get('/userinfo/channelDealRate/export', {
          params: params,
          responseType: 'arraybuffer'
        }).then((response) => {
          if (response.data) {
            let blob = new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
            let link = document.createElement('a')
            link.target = '_blank'
            link.href = window.URL.createObjectURL(blob)
            link.download = '渠道成交率-' + this.startDate + '_' + this.endDate + '.xlsx'
            link.click()
            this.exportLoading = false
          } else {
            this.$Message.error(response.msg || '导出失败')
            this.exportLoading = false
          }
        }).catch(() => {
          this.$Message.error('导出失败')
          this.exportLoading = false
        })
      },
      search () {
        this.searchLoading = true
        const seq = (this.searchSeq || 0) + 1
        this.searchSeq = seq
        const params = {
          startDate: this.startDate,
          endDate: this.endDate
        }
        if (this.dimension === 'category') {
          params.dimension = 'category'
        } else if (this.marketCategoryKey) {
          params.marketCategory = this.marketCategoryKey
        }
        this.$http.get('/userinfo/channelDealRate', {
          params: params
        }).then(res => {
          if (seq !== this.searchSeq) {
            return
          }
          const data = res.data || {}
          this.list = data.list || []
          this.totalAssignCount = data.totalAssignCount || 0
          this.totalDealCount = data.totalDealCount || 0
          this.totalDealRate = data.totalDealRate
          this.totalCurrentDealCount = data.totalCurrentDealCount || 0
          this.totalCurrentDealRate = data.totalCurrentDealRate
          if (data.weekStart && data.weekEnd) {
            this.setRange(data.weekStart, data.weekEnd)
          }
          if (this.dimension !== 'category') {
            this.syncLevelQuery()
          }
          this.searchLoading = false
        }).catch(() => {
          if (seq !== this.searchSeq) {
            return
          }
          this.searchLoading = false
        })
      }
    }
  }
</script>
<style lang="less" scoped>
.list /deep/ .ivu-table-tbody tr.low-deal-rate td {
  background-color: #fff1f0;
}
.list /deep/ .ivu-table-tbody tr.low-deal-rate:hover td {
  background-color: #ffe8e6;
}
</style>



// WEBPACK FOOTER //
// ChannelDealRate.vue?cbec0d16